<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template v-if="noChild(item)">
      <app-link :to="resolvePath(item.path)">
        <el-menu-item
          :index="resolvePath(item.path)"
          @click="goRouter(item.path)"
        >
          <item :title="item.meta.title" @click="goRouter(item.path)" />
        </el-menu-item>
      </app-link>
    </template>
    <el-submenu
      v-else
      ref="subMenu"
      :index="resolvePath(item.path)"
      popper-append-to-body
    >
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="item.meta.title"
          :index="resolvePath(item.path)"
        /><span
          v-if="item.meta.title === '锐锢在线' && orderTotal && orderTotal > 0"
          class="menu-warpper-msg"
          >{{ orderTotal > 99 ? "99+" : orderTotal }}</span
        >
      </template>

      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import Item from "./Item";
import AppLink from "./Link";
import { mapGetters } from "vuex";
// import FixiOSBug from './FixiOSBug'

export default {
  name: "SidebarItem",
  components: { Item, AppLink },
  computed: {
    ...mapGetters(["orderTotal"])
  },
  // mixins: [FixiOSBug],
  inject: ["routeReload"],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    }
  },
  data() {
    this.onlyOneChild = null;
    return {};
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }
      if (showingChildren.length === 0) {
        return false;
      }

      // Show parent if there are no child router to display
      // if (showingChildren.length === 0) {
      //   this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
      //   return false
      // }

      return false;
    },
    noChild(item) {
      if (item && item.children) {
        let arr = item.children.filter(c => {
          return !c.hidden;
        });

        if (arr.length === 0 && item.meta && !item.meta.isParent) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    resolvePath(routePath) {
      return routePath;
      // if (isExternal(routePath)) {
      //   return routePath
      // }
      // if (isExternal(this.basePath)) {
      //   return this.basePath
      // }
      // return path.resolve(this.basePath, routePath)
    },
    goRouter(path) {
      localStorage.setItem("menuActive", path);
      try {
        if (path === this.$route.path) {
          this.routeReload(); // 跳转页面想同则刷新当前页面
        } else {
          this.$router.push(path);
        }
      } catch (err) {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/SiderBar/SidebarItem.vue